import type { Item } from 'analytics/utils/getEECItems/getEECItems'
import { create } from 'zustand'

export type AnalyticsImpressionsStore = {
	impressions: Item[]
	addImpression: (impression: Item) => void
	resetImpressions: () => void
}

export const useAnalyticsImpressionsStore = create<AnalyticsImpressionsStore>()(
	(set) => ({
		impressions: [],
		addImpression: (impression: Item) =>
			set((state) => ({ impressions: state.impressions.concat(impression) })),
		resetImpressions: () => set(() => ({ impressions: [] })),
	})
)
